import React from 'react';
import { Box } from '@chakra-ui/react';
import { TicketView } from '../organisms/TicketView';
import { Settings } from '../../interfaces';
import { useSettings } from '../../stateManagement/SettingsContext';
import { Layout } from '../templates';

export interface TicketPagePreviewProps {
  settings: Settings;
  onClickMyTickets: () => void;
  onClickLandingPageButton: () => void;
  onContactUsClick: () => void;
}

export const TicketPagePreview: React.FC<TicketPagePreviewProps> = ({
  settings,
  onClickMyTickets,
  onClickLandingPageButton,
  onContactUsClick,
}) => {
  const { dummyMyTicketsData } = useSettings(); // now from context
  const data = dummyMyTicketsData?.dataInTicket;
  const handleBackClick = () => {
    onClickMyTickets();
  };
  return (
    <Layout
      onClickLandingPageButton={onClickLandingPageButton}
      onClickMyTickets={onClickMyTickets}
      onContactUsClick={onContactUsClick}
      pageBgColor={settings?.configs.secondaryBgColor}
      settings={settings}
      isPreviewMode
    >
      <Box>
        <Box
          display="flex"
          flexDirection="column"
          minHeight="76vh"
          backgroundColor={settings?.configs.secondaryBgColor}
        >
          <Box flex={1}>
            <TicketView
              ticketData={data}
              settings={settings}
              showHelperButton={false}
              handleBackClick={handleBackClick}
              rocksImageUrl={settings.configs.rocksImageUrl}
            />
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};
